import { hexFromArgb } from '@material/material-color-utilities'
import clsx from 'clsx'

import { generateColorTokensV2 } from '@makyoapp/makyo-tw-ui'

import { BrandKit } from '@/shared/brand-kit'

interface BrandKitColorPreviewProps {
  brandKit: BrandKit
  defaultHeight?: boolean
  className?: string
  mode?: 'dark' | 'light'
}

export function BrandKitColorPreview({
  brandKit,
  defaultHeight = true,
  className,
  mode = 'light',
}: BrandKitColorPreviewProps) {
  const defaultColor = brandKit?.colors?.find((c) => c.isDefault)
  const initialSourceColor = defaultColor?.value ? hexFromArgb(defaultColor.value) : ''

  if (!initialSourceColor) return null

  const { palettes } = generateColorTokensV2(initialSourceColor, mode)

  const modeIndex = mode === 'light' ? 0 : 1
  const primaryBg = palettes.primary[50][0]
  const secondaryBg = palettes.secondary[50][0]
  const tertiaryBg = palettes.tertiary[50][0]
  const neutralBg = palettes.neutral[70][modeIndex]

  return (
    <div
      className={clsx(
        'mk-bk-color-preview flex overflow-hidden',
        defaultHeight && 'h-6',
        className
      )}
    >
      <div className='mk-bk-color-wrap flex w-full'>
        <div className='mk-bk-color w-full h-full' style={{ backgroundColor: primaryBg }} />
        <div className='mk-bk-color w-full h-full' style={{ backgroundColor: secondaryBg }} />
        <div className='mk-bk-color w-full h-full' style={{ backgroundColor: tertiaryBg }} />
        <div className='mk-bk-color w-full h-full' style={{ backgroundColor: neutralBg }} />
      </div>
    </div>
  )
}
